const menuItems = [
    {
      id: 1,
      path: "/",
      name: "Home",
    },
    {
      id: 2,
      path: "#",
      name: "Society",
      subMenu: [
        {
          id: 1,
          name: "About",
          path: "/society/",
        },
        // {
        //   id: 2,
        //   name: "News",
        //   path: "/society/news",
        // },
        {
          id: 3,
          name: "Competition",
          path: "#",
          subMenu: [
            {
              id: 1,
              name: "About",
              path: "/society/competition/",
            },
            {
              id: 2,
              name: "Classes",
              path: "/society/competition/classes",
            },
            {
              id: 3,
              name: "Scoring",
              path: "/society/competition/scoring",
            },
            {
              id: 4,
              name: "Venues",
              path: "/society/competition/venues",
            },
            {
              id: 5,
              name: "Results",
              path: "/society/competition/results",
            },
          ]
        },
      ]
    },
    {
      id: 3,
      path: "#",
      name: "Membership",      
      subMenu: [
        {
          id: 1,
          name: "Details",
          path: "/membership/",
        },
        {
          id: 2,
          name: "Application",
          path: "/membership/application",
        },
      ]
    },
    {
      id: 4,
      path: "#",
      name: "Extras",
      subMenu: [
        {
          id: 1,
          name: "Photographs",
          path: "/gallery/",
        },
        {
          id: 2,
          name: "Videos",
          path: "/videos/",
        },
        {
          id: 3,
          name: "Links",
          path: "/links/",
        },
      ],
    },
    {
      id: 5,
      path: "/contact-us/",
      name: "Contact",
    }
  ];
  
export default menuItems;
